import { render, staticRenderFns } from "./board-changelog-collapse.vue?vue&type=template&id=2199d61e"
import script from "./board-changelog-collapse.vue?vue&type=script&lang=js"
export * from "./board-changelog-collapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports